import { OrderStatusEnumResponseDto } from '@core/services/apiclient';

// seat status as numbers
export const OrderSeatsIds: { [key: string]: number } = {};
OrderSeatsIds[OrderStatusEnumResponseDto.Free] = 0;
OrderSeatsIds[OrderStatusEnumResponseDto.Reserved] = 100;
OrderSeatsIds[OrderStatusEnumResponseDto.Paid] = 200;
OrderSeatsIds[OrderStatusEnumResponseDto.EditionStarted] = 300;
// the factor with which zooming will scale: the event will scale dimensions * 1.5 each time
export const ZoneviewScaleByFactor = 1.5;
// the factor with which the minimap will be scaled: 0.25 of the real plan
export const MinimapScaleFactor = 0.25;
// blocked seat icon
export const BlockedSeatIcon = 'assets/icons/blocked-seat.svg';
// search result icon
export const SearchResultIcon = 'assets/icons/seat-search-result.svg';
// parent groups will have 5000 seats, every time the view is updated, only the selected seats' groups will be refreshed
export const SeatsPerGroup = 5000;
// seat box width and height
export const SeatBoxSize = 12;
// synchronizing local and remote selection will be executed after this timeout value (in ms)
export const SynchronizeSelectionUpdateTimeout = 2000;
// Topview is scaled up to 4 times with zooming event
export const TopviewMaxScaleValue = 4;
// ratio to apply cache to the plan, 10 is the best value to get performance and quality on medium size plans
// you can move this constant to a configurable file, and adjust its value according to the plans sizes by database
export const BlockviewCachePixelRatio = 10;
